import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const SamsaraVehicle = lazyLoader(
  () => import("Containers/SamsaraIntegration/SamsaraVehicle/SamsaraVehicle")
);

export const SamsaraVehiclePage = () => {
  return (
    <Layout>
      <SamsaraVehicle />
    </Layout>
  );
};
